<template lang="pug">
  md-dialog(:md-active.sync="open" @md-closed="handleCloseModal")
    button.modal-close(@click="handleCloseModal") X

    md-dialog-title.text-center {{ modalTitle }}

    md-dialog-content(v-if="isForm")
      form(@submit.prevent="handleFormSubmit")
        slot
        md-dialog-actions
          md-button(@click="handleCloseModal") Close
          md-button.md-primary(type="submit") {{ submitButtonText }}
    template(v-else)
      md-dialog-content
        slot
      md-dialog-actions
        md-button(@click="handleCloseModal") Close
        slot(name="dialog-actions")
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    handleCloseModal: {
      type: Function,
      required: true,
    },
    handleFormSubmit: {
      type: Function,
      default: () => console.error('Missing handleFormSubmit props on form modal.'),
    },
    modalTitle: {
      type: String,
      default: 'Modal',
    },
    isForm: {
      type: Boolean,
      default: false,
    },
    submitButtonText: {
      type: String,
      default: 'Save',
    },
  },

  data() {
    return {
      open: this.showModal,
    };
  },

  watch: {
    showModal(current, old) {
      if (current !== old) {
        this.open = current;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.5rem 1rem;
  background-color: lighten($main, 10%);
  border: none;
  border-radius: 0 0 0 4px;
  color: white;
  cursor: pointer;
  outline: none;
  transition: background-color 200ms ease;

  &:hover {
    background-color: $main;
  }
}
</style>
